import _ from 'lodash';

// Checks if all properties of an object are undefined or null
export const isObjectEmpty = (o) =>{
    return !_.values(o).some(x => x !== undefined && x!==null); 
} 

/**
 *  Check if obj is an object but not an array
 * @param {*} obj 
 * @returns true if object
 */
export const isObjectNotArray = (obj)=> {
    return _.isObject(obj) && !Array.isArray(obj)
}

/**
 * Check if value is nullish (undefined or null)
 * @param {*} value 
 * @returns  {bool} True if value is null or undefined
 */
export const isNullish = (value) => {
    return (value === undefined || value === null)
}

/*
 *  Checks an object of variable has
 * @param {*} value 
 * @returns 
 */
export const isObjectEmptyOrNull = (value) => {
    return value === undefined
        || value === null
        || (typeof value === 'object' && Object.keys(value).length === 0)
}

/**
 * Checks if parameter is a sting
 * @param {*} value 
 * @returns 
 */
export const isString = (value) => {
    return typeof value === 'string' || value instanceof String;
}
